import { FC, ReactNode } from 'react';

interface TabGroupProps {
  children: ReactNode;
  className?: string;
}

const PayoutTabGroup: FC<TabGroupProps> = ({ children, className = '' }) => {
  return <div className={`flex justify-between rounded-md bg-secondaryBtn p-1 ${className}`}>{children}</div>;
};

export default PayoutTabGroup;
